
import {
    SOLICITUDINDI_LOADING,
    SOLICITUDINDI_LOADED,
    SOLICITUDINDI_ERROR,

    SOLICITUD_LOADING,
    SOLICITUD_LOADED,
    SOLICITUD_ERROR,

    SOLICITUDCREAR_LOADING,
    SOLICITUDCREAR_LOADED, 
    SOLICITUDCREAR_ERROR,
    
    SOLICITUDEDITAR_LOADING,
    SOLICITUDEDITAR_LOADED,
    SOLICITUDEDITAR_ERROR,

    SOLICITUDELIMINAR_LOADING,
    SOLICITUDELIMINAR_LOADED,
    SOLICITUDELIMINAR_ERROR,
  } from "./../../types/solicitudes";

const INITIAL_STATE = {
    isLoading: false,
    solicitudes: null,
    solicitudcrear:null,
    solicitud: null,
    error: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case SOLICITUDINDI_LOADING:
            return {
                ... state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:null,
                solicitud: null,
                error: ''
            }
        case SOLICITUDINDI_LOADED:
            return {
                ...state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:null,
                solicitud: action.payload,
                error: ''
            };
        case SOLICITUDINDI_ERROR:
            return {
                ...state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:null,
                solicitud: null,
                error: action.payload
            }

        case SOLICITUD_LOADING:
            return {
                ... state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:null,
                solicitud: null,
                error: ''
            }
        case SOLICITUD_LOADED:
            return {
                ...state,
                isLoading : false,
                solicitudes: action.payload,
                solicitudcrear:null,
                solicitud: null,
                error: ''
            };
        case SOLICITUD_ERROR:
            return {
                ...state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:null,
                solicitud: null,
                error: action.payload
            }

        case SOLICITUDCREAR_LOADING:
            return {
                ... state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:null,
                solicitud: null,
                error: ''
            }
        case SOLICITUDCREAR_LOADED:
            return {
                ...state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:action.payload,
                solicitud: null,
                error: ''
            };
        case SOLICITUDCREAR_ERROR:
            return {
                ...state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:null,
                solicitud: null,
                error: action.payload
            }

        case SOLICITUDEDITAR_LOADING:
            return {
                ... state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:null,
                solicitud: null,
                error: ''
            }
        case SOLICITUDEDITAR_LOADED:
            return {
                ...state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:action.payload,
                solicitud: null,
                error: ''
            };
        case SOLICITUDEDITAR_ERROR:
            return {
                ...state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:null,
                solicitud: null,
                error: action.payload
            }

        case SOLICITUDELIMINAR_LOADING:
            return {
                ... state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:null,
                solicitud: null,
                error: ''
            }
        case SOLICITUDELIMINAR_LOADED:
            return {
                ...state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:action.payload,
                solicitud: null,
                error: ''
            };
        case SOLICITUDELIMINAR_ERROR:
            return {
                ...state,
                isLoading : false,
                solicitudes: null,
                solicitudcrear:null,
                solicitud: null,
                error: action.payload
            }
        default: return state;
    }
}